import { render } from "./Jobdetails.vue?vue&type=template&id=2fe8b08a&scoped=true"
import script from "./Jobdetails.vue?vue&type=script&lang=js"
export * from "./Jobdetails.vue?vue&type=script&lang=js"

import "./Jobdetails.vue?vue&type=style&index=0&id=2fe8b08a&scoped=true&lang=css"

import exportComponent from "/home/trit/trit/dev/caspwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe8b08a"]])

export default __exports__